module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.8a8c047.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff2
// module id = 4dHM
// module chunks = 0